import ContentHeader from "@/components/feature/ContentHeader";
import Footer from "@/pages/home/components/Footer";

export interface LegalSection {
  heading: string;
  body: string[];
}

interface LegalPageProps {
  eyebrow: string;
  title: string;
  updated: string;
  intro: string;
  sections: LegalSection[];
}

export default function LegalPage({ eyebrow, title, updated, intro, sections }: LegalPageProps) {
  return (
    <div className="relative min-h-screen bg-background-50 overflow-x-hidden">
      <ContentHeader />

      <main>
        <section className="relative pt-32 pb-12 md:pt-40 md:pb-16 px-4 md:px-8">
          <div className="absolute -top-24 -right-24 w-[420px] h-[420px] rounded-full joble-glow-accent pointer-events-none"></div>
          <div className="relative max-w-3xl mx-auto">
            <div className="inline-flex items-center gap-2 rounded-full border border-background-300/50 bg-background-100/60 px-4 py-1.5 mb-6">
              <span className="w-2 h-2 rounded-full bg-accent-400"></span>
              <span className="text-xs font-medium text-foreground-800 tracking-wide">
                {eyebrow}
              </span>
            </div>
            <h1 className="font-heading text-4xl sm:text-5xl md:text-6xl font-normal text-foreground-950 tracking-tight leading-[1.1]">
              {title}
            </h1>
            <p className="mt-5 text-sm font-medium text-foreground-500">{updated}</p>
            <p className="mt-6 text-base md:text-lg text-foreground-700 leading-relaxed">{intro}</p>
          </div>
        </section>

        <section className="relative pb-20 md:pb-28 px-4 md:px-8">
          <div className="max-w-3xl mx-auto">
            <div className="flex flex-col gap-10">
              {sections.map((section, index) => (
                <article
                  key={section.heading}
                  className="border-t border-background-300/30 pt-8 first:border-t-0 first:pt-0"
                >
                  <div className="flex items-baseline gap-3 mb-4">
                    <span className="text-xs font-semibold tracking-[0.2em] text-foreground-400">
                      {String(index + 1).padStart(2, "0")}
                    </span>
                    <h2 className="font-heading text-xl md:text-2xl font-medium text-foreground-950 tracking-tight">
                      {section.heading}
                    </h2>
                  </div>
                  <div className="space-y-4 text-sm md:text-base text-foreground-700 leading-relaxed">
                    {section.body.map((paragraph) => (
                      <p key={paragraph.slice(0, 40)}>{paragraph}</p>
                    ))}
                  </div>
                </article>
              ))}
            </div>

            <div className="mt-14 rounded-2xl border border-primary-500/20 bg-primary-500/[0.07] p-7 md:p-8">
              <h2 className="text-lg font-semibold text-foreground-950 mb-2">Questions?</h2>
              <p className="text-sm text-foreground-700 leading-relaxed">
                Reach us any time at{" "}
                <a
                  href="mailto:support@joble.app"
                  className="font-semibold text-primary-700 hover:underline cursor-pointer"
                >
                  support@joble.app
                </a>{" "}
                and a real person will get back to you.
              </p>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}